export const GET_REFERRAL_INFORMATION = 'GET_REFERRAL_INFORMATION';